"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const objectSetValueByPath = (original, path, value) => {
    if (path.length === 0) {
        return original;
    }
    if (path.length === 1) {
        const [propName] = path;
        if ((0, ts_validators_1.valueIsString)(propName) && (0, ts_validators_1.valueIsRecord)(original)) {
            return Object.assign(Object.assign({}, original), { [propName]: value });
        }
    }
    const [currentProp, ...restOfPath] = path;
    if ((0, ts_validators_1.valueIsRecord)(original)) {
        const targetValue = original[currentProp];
        if (!(0, ts_validators_1.valueIsRecord)(targetValue) && !(0, ts_validators_1.valueIsArray)(targetValue)) {
            return Object.assign(Object.assign({}, original), { [currentProp]: objectSetValueByPath({}, restOfPath, value) });
        }
        return Object.assign(Object.assign({}, original), { [currentProp]: objectSetValueByPath(targetValue, restOfPath, value) });
    }
    if (!(0, ts_validators_1.valueIsNumber)(currentProp)) {
        throw new Error('When mutating an array, the path should always be a number');
    }
    const targetValue = original[currentProp];
    const newArray = [...original];
    if (restOfPath.length < 1) {
        newArray[currentProp] = value;
    }
    else {
        if (!(0, ts_validators_1.valueIsRecord)(targetValue) && !(0, ts_validators_1.valueIsArray)(targetValue)) {
            throw new Error('Should always find a record or array here');
        }
        newArray[currentProp] = objectSetValueByPath(targetValue, restOfPath, value);
    }
    return newArray;
};
exports.default = objectSetValueByPath;
